export enum SearchSelector {
  DueDate = 'dueDate',
  Product = 'product',
  Arn = 'arn',
  ChargebackType = 'chargebackType',
  OpenedDate = 'openedDate',
  OpenedDateFrom = 'openedDateFrom',
  OpenedDateTo = 'openedDateTo',
  DetailedStatus = 'detailedStatus',
  MerchantUuid = 'merchantUuid',
  ReasonType = 'reasonCode',
}
